<!--<script src="https://www.google.com/recaptcha/enterprise.js?render=6LcqsHEqAAAAAL73RizMTKpOE1lteQFNJoUNApzX"></script><!-->
  <!--<div style="width: 500px; height:  500px;">
    <div id="recaptcha-container"></div>
    <input type="tel" [(ngModel)]="phoneNumber" placeholder="Numéro de téléphone">
    <button (click)="sendVerificationCode()">Envoyer le code</button>
    <input type="text" [(ngModel)]="verificationCode" placeholder="Code de vérification">
    <button (click)="verifyCode()">Vérifier</button>
  </div>-->





  


  <div class="container" style="display: flex; flex-direction: column; height: 100%; width: 100%; min-height: 77vh; justify-content: center; align-items: center;">

    


      <!-- Étape 1 : Sélecteur de pays et numéro de téléphone -->
      <div
      class="step-container"
      *ngIf="currentStep === 1"
      >
      <div class="auth-container">
        <!-- Bouton Play/Pause -->
        <div class="audio-container">
          <button mat-icon-button class="play-pause-button" (click)="toggleAudio($event)">
            <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
          </button>
          <audio #audioPlayer preload="auto" src="../../../assets/audio/setup_country_flag_bambara.m4a.mp3"></audio>
      
        </div>
        
        <div class="box1">
          <img src="../../../assets/images/Lenali_logo_Full.png" alt=""  class="lenali-logo">
          <h4 style="font-weight: bold; color: #08a8ff;">Pays et numéro</h4>
        </div>
      
        <!-- Sélecteur de pays -->
        <h5>Pays</h5>
        <div class="phone-input">
          <select [(ngModel)]="selectedDialCode" #countrySelect (change)="onCountryChange($event)">
            <option *ngFor="let country of countries" 
            [value]="country.dialCode"
            [selected]="country.dialCode === selectedDialCode">
              {{ country.flag }}  ({{ country.dialCode }}) {{ country.name }}
            </option>
          </select>
          
          <br>
        </div>
        <br>
  
        <!-- Numéro de téléphone -->
        <h5>Numéro de téléphone</h5>
        <div class="phone-input">
          <input type="text" placeholder="Numéro de téléphone" #phoneNumber />
        </div>
        
        <!-- Bouton pour envoyer OTP -->
        <button class="btn-send" (click)="sendOTP(phoneNumber.value)">
          Suivant
        </button>
        <br>
        
      
        <!-- Vérification du code OTP -->
        <div *ngIf="isCodeSent" class="otp-section">
          <input
            type="text"
            placeholder="Entrez le code OTP"
            [(ngModel)]="verificationCode"
          />
          <button class="btn-verify" (click)="verifyCode()">Vérifier le code</button>
        </div>
      </div>

       
      <br>
    </div>


    <!-- Étape 2 : Vérification OTP -->
    <div
      class="step-container"
      *ngIf="currentStep === 2"
      [@slideInOut]>
      <div class="auth-container">
        <div class="audio-container">
          <button mat-icon-button class="play-pause-button" (click)="toggleAudio($event)">
            <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
          </button>
          <audio #audioPlayer preload="auto" src="../../../assets/audio/setup_enter_sms_code_bambara.m4a.mp3"></audio>
      
        </div>

        <div class="box1">
          <img src="../../../assets/images/Lenali_logo_Full.png" alt=""  class="lenali-logo">
          <h4 style="font-weight: bold; color: #08a8ff;">Confirmation de code</h4>
        </div>


        <br>
        <!-- Vérification du code OTP -->
        <h4 style="font-weight: bold; ">Entrez le code SMS reçu</h4>
        <div class="otp-section">
          <input type="text" placeholder="Entrez le code OTP" [(ngModel)]="verificationCode" />
        </div>
        <br>
        <br>
        <br>
        <button class="btn-verify" (click)="verifyCode()">Suivant</button>

        
      </div>
  
    </div>

    <!-- Conteneur reCAPTCHA -->
    <div style="max-width: 50px ; border: 1px ; overflow: hidden;">
      <div id="recaptcha-container" style="max-width: 100%; overflow: hidden; display: none;"></div>
    </div>


  </div>

  
  



  

  